import React, { useState } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import LightGallery from 'lightgallery/react';
// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

import break_box from '../../../images/product/break_box.png';

const Renewal = ({ show, onClose }) => {
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    const options_payment_mode = [
        { value: "0", label: "Select Payment Mode" },
        { value: "1", label: "Paypal" },
        { value: "2", label: "Pay U" },
        { value: "3", label: "Paytm" },
        { value: "4", label: "Google Pay" },
        { value: "5", label: "Bank" },
        { value: "6", label: "Cash" },
        { value: "7", label: "Cheque" },
        { value: "8", label: "Swipe Machine" },
    ];

    const [selectedOption, setSelectedOption] = useState(null);


    return (
        <Modal show={show} size="md"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Subscription Renewal</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                    {/* <div>
                        <Badge bg="warning" className='text-black fs-8 py-0 px-1'>Weekly</Badge>
                    </div> */}
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <div className="row mb-2">
                                <label className="col-4 text-black fs-7">Subscriber</label>
                                <label className="col-1 text-black fs-6">:</label>
                                <label className="col-7 text-black font-w500 fs-6">Nirmal</label>
                            </div>
                            <div className="row mb-2">
                                <label className="col-4 text-black fs-7">Mobile No</label>
                                <label className="col-1 text-black fs-6">:</label>
                                <label className="col-7 text-black font-w500 fs-6">9656857445</label>
                            </div>
                            <div className="row mb-2">
                                <label className="col-4 text-black fs-7">Email ID</label>
                                <label className="col-1 text-black fs-6">:</label>
                                <label className="col-7 text-black font-w500 fs-6">nirmal@gmail.com</label>
                            </div>
                        </div>
                        <div className="col-lg-12 mb-4">
                            <div className="d-flex align-items-center justify-content-between gap-2">
                                <div className='d-flex align-items-center mb-0'>
                                    <LightGallery
                                        onInit={onInit}
                                        speed={500}
                                        plugins={[lgThumbnail, lgZoom]}
                                    >
                                        <div data-src={break_box} className='border rounded px-1 py-0 me-1'>
                                            <img src={break_box} alt="gallery" className='cursor-pointer w-80px h-80px' />
                                        </div>
                                    </LightGallery>
                                    <div>
                                        <label className='text-black font-w500 fs-5'>Break Box</label>
                                        <div className="d-block">
                                            <label className="fs-6 text-dark font-w500">Mini</label>
                                        </div>
                                        <div className='d-block'>
                                            <label className='me-2'><i className="fa-solid fa-indian-rupee-sign text-primary fs-4"></i></label>
                                            <label className='fs-3 text-primary font-w600'>750</label>
                                        </div>
                                    </div>
                                </div>
                                <div className='mb-0 text-center'>
                                    <div className='d-block mb-2'>
                                        <label><i className="fa-regular fa-clock me-2 fs-4 text-info"></i></label>
                                        <label className='fs-4 text-black font-w500'>Service Time</label>
                                    </div>
                                    <div className='d-block'>
                                        <label className='fs-7 text-primary font-w600'>07:00 AM</label>
                                        <label className='fs-7 text-black font-w500 ms-2 me-2'>to</label>
                                        <label className='fs-7 text-danger font-w600'>08:00 AM</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <Divider></Divider> */}
                    <div className="row">
                        <div className="col-lg-6 mb-4">
                            <label className="text-black font-w500 fs-7">Start Date<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4 text-danger'></i></div>
                                <DatePicker placeholder='Select Date'
                                    value={selectedOption}
                                    format="DD-MM-YYYY"
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4">
                            <label className="text-black font-w500 fs-7">End Date</label>
                            <div className='datepicker-wrapper d-flex'>
                                <DatePicker placeholder='Select Date'
                                    value={selectedOption}
                                    format="DD-MM-YYYY"
                                />
                            </div>
                        </div>
                    </div>
                    <div className='row mb-2'>
                        <div className='col-lg-12 d-flex justify-content-between mb-2'>
                            <div className='text-black font-w500 fs-4'>Sub Total</div>
                            <div>
                                <label className='text-black font-w500 fs-3'>
                                    <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                    <span>750</span>
                                </label>
                            </div>
                        </div>
                        <div className='col-lg-12 d-flex justify-content-between mb-2'>
                            <div className='text-black font-w500 fs-5'>
                                <lable className='text-black font-w500 fs-5'>GST</lable>
                                <lable className='text-danger font-w600 fs-5 ms-1'>( 5% )</lable>
                            </div>
                            <div className='text-black font-w500 fs-4'>
                                <label className='text-black font-w500 fs-4'><i className="fa-solid fa-indian-rupee-sign me-2"></i></label>
                                <label className='text-black font-w500 fs-4'>38</label>
                            </div>
                        </div>
                        <div className='col-lg-12 d-flex justify-content-between mb-2'>
                            <label className='text-black font-w500 fs-3'>Total Amount</label>
                            <div>
                                <label className='text-danger fw-bold fs-2'>
                                    <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                    <span>788</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    {/* <Divider></Divider>  */}
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Renewal</Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Renewal;
